import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sortByOrder } from "../helpers";
import api from "../providers/api";

const initialState = {
  strategies: [],
  isLoading: true,
};

export const getObjectives = createAsyncThunk(
  "get-objectives",
  async (strategyType) => {
    const response = await api.strategy.getAllWithObjectives({
      strategyType: +strategyType,
    });

    const keyName = +strategyType === 1 ? "Themes" : "Pillars";

    return response.Data.map((item) => {
      return {
        ...item,
        [keyName]: item?.[keyName].map((e) => {
          return {
            ...e,
            // Objectives: sortByOrder(e.Objectives),
            Objectives: e.Objectives,
          };
        }),
      };
    });
  }
);

const objectiveSlice = createSlice({
  name: "objectives",
  initialState,
  reducers: {
    updateObjective: (state, { payload }) => {
      if (state.strategies?.length === 0) return;

      const keyName = +payload?.StrategyType === 1 ? "Themes" : "Pillars";
      const itemKeyName = +payload?.StrategyType === 1 ? "Theme" : "Pillar";

      const _strategies = state.strategies.map((item) => {
        return {
          ...item,
          [keyName]: item?.[keyName].map((e) => {
            return {
              ...e,
              Objectives: e.Objectives.filter((obj) => {
                return obj.ID !== payload.ID;
              }),
            };
          }),
        };
      });

      const strategyIndex = _strategies.findIndex((x) =>
        x?.[keyName].some((e) => e.ID === payload?.[itemKeyName].ID)
      );

      const parentIndex = _strategies[strategyIndex]?.[keyName].findIndex(
        (e) => e.ID === payload?.[itemKeyName].ID
      );

      _strategies?.[strategyIndex]?.[keyName][parentIndex].Objectives.push(
        payload
      );

      _strategies[strategyIndex][keyName][parentIndex].Objectives = sortByOrder(
        _strategies[strategyIndex]?.[keyName][parentIndex].Objectives
      );

      state.strategies = _strategies;
    },
    deleteObjective: (state, { payload: { strategyIndex, id, type } }) => {
      const keyName = +type === 1 ? "Themes" : "Pillars";

      const parentIndex = state.strategies[strategyIndex]?.[keyName].findIndex(
        ({ Objectives }) => Objectives.some((e) => e.ID === id)
      );

      const itemIndex = state.strategies[strategyIndex]?.[keyName][
        parentIndex
      ].Objectives.findIndex((so) => so.ID === id);

      if (itemIndex !== -1) {
        state.strategies[strategyIndex]?.[keyName][
          parentIndex
        ].Objectives.splice(itemIndex, 1);
      }
    },
  },
  extraReducers: {
    [getObjectives.fulfilled]: (state, action) => {
      state.strategies = action.payload;
      state.isLoading = false;
    },
    [getObjectives.pending]: (state) => {
      state.isLoading = true;
    },
    [getObjectives.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { updateObjective, deleteObjective } = objectiveSlice.actions;

export default objectiveSlice.reducer;
